const REQUIRED_FIELD = 'Required field'
const INVALID_EMAIL = 'Invalid email'
const INVALID_PASSWORD = 'Password must be more than 4 characters'


const EMAIL_REGEXP =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu

export const validationHandlerEmailProfile = (value) => {
    if (!isEmailValid(value)) {
        return INVALID_EMAIL
    }
    return ''
}

export const validationHandlerPassword = (value) => {
    if (!value) {
        return REQUIRED_FIELD
    }
    if (value?.length < 5) {
        return INVALID_PASSWORD
    }
    return ''
}


export const isEmailValid = value => EMAIL_REGEXP.test(value)